/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Common_Not_Found_NoteInputs */

const da_common_not_found_note = /** @type {(inputs: Common_Not_Found_NoteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Linket kan være forældet, eller siden er flyttet. Det, du har gemt eller godkendt, er ikke berørt.`)
};

/** @type {(inputs: Common_Not_Found_NoteInputs) => LocalizedString} */
const en_common_not_found_note = da_common_not_found_note;

/**

* @param {Common_Not_Found_NoteInputs} inputs
* @param {{ locale?: "da" | "en" }} options
* @returns {LocalizedString}
*/
export const common_not_found_note = /** @type {((inputs?: Common_Not_Found_NoteInputs, options?: { locale?: "da" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Common_Not_Found_NoteInputs, { locale?: "da" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_common_not_found_note(inputs)
	return /** @type {LocalizedString} */ ("Linket kan være forældet, eller siden er flyttet. Det, du har gemt eller godkendt, er ikke berørt.")
});